export const SLICE_NAME = 'companyDashboard';
